import styled from "styled-components";

import { COVERS_HALFCARD_CONSTANTS } from "./constant";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.large,
    alignItems: "stretch",
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
}));

export const IllustrationContainer = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const IconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: COVERS_HALFCARD_CONSTANTS.ICON_WRAPPER_SIZE,
    height: COVERS_HALFCARD_CONSTANTS.ICON_WRAPPER_SIZE,
    borderRadius: theme.cornerRadius.rounded,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
}));

export const TextContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    alignItems: "center",
    textAlign: "center",
}));

export const InputWrapper = styled.div(({ theme }) => {
    const { fontSize, fontWeight, lineHeight, fontFamily, letterSpacing } =
        theme.typography["V2.body3.neutral.medium"];
    const inputTypography = { fontSize, fontWeight, lineHeight, fontFamily, letterSpacing };
    return {
        width: "100%",
        "& input": inputTypography,
        "& input::placeholder": inputTypography,
    };
});

export const CTAWrapper = styled.div({
    width: "100%",
});
